import { AssetEvent } from '@/types/assets';
import { AssetEventSource } from '@electricjs/core_entity-client';
import { TFunction } from 'i18next';
import { mapActionTypeToEventDescription } from './AssetEventHistoryFormatters';

export const formatActionType = (actionType: string): string => {
  const splitActionType = actionType.split(' ');

  const [start, ...rest] = splitActionType;
  const formattedStart = start.toLowerCase();

  if (rest.length === 0) {
    return formattedStart;
  }

  let formattedRest = formattedStart;
  const response = rest.map(word => {
    if (word === 'MDM') {
      word = 'Mdm';
    }
    const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
    formattedRest += capitalizedWord;
    return formattedRest;
  });

  return response.at(-1) ?? '';
};

export const formatEventDescription = (event: AssetEvent, t: TFunction) => {
  if (event.source === AssetEventSource.Jumpcloud) {
    return event.action;
  }

  const eventType = event.actionType;

  if (Object.keys(mapActionTypeToEventDescription).includes(eventType)) {
    const translationResult = mapActionTypeToEventDescription[
      eventType as keyof typeof mapActionTypeToEventDescription
    ](event.action, t);
    if (translationResult) {
      return translationResult;
    }
  }
  //fallback to original action string if no translation is found
  return event.action;
};
